const timelineData = [
  {
    text: "IBM data science",
    date2: "October 2022",
    paragraph: "Coursera - IBM",
    first: "Specialization, data science introduction",

    category: {
      tag: "DS specialization",
      color: "#6a5acd",
    },
  },
  {
    text: "Neural Networks and Deep Learning",
    date2: "September 2022",
    paragraph: "Coursera - Deeplearning.ai",
    first: "Course for learning the basics of deep learning",

    category: {
      tag: "ML specialization",
      color: "#6a5acd",
    },
  },
  {
    text: "Databases and SQL for Data Science with Python",
    date2: "September 2022",
    paragraph: "Coursera - honors certification",
    first: "Course for working with SQL an Python",

    category: {
      tag: "Coursera honors",
      color: "#6a5acd",
    },
  },
  {
    text: "Google Data Analytics",
    date2: "September 2022",
    paragraph: "Coursera - Google",
    first: "- Specialization of 8 coursers for introduction to data analysis",

    category: {
      tag: "data analytics specialization",
      color: "#6a5acd",
    },
  },
  {
    text: "ML specialization",
    date2: "August 2022",
    paragraph: "Coursera - Deeplearnig.ai",
    first: "- Specialization of 3 coursers for deep learning and ML",

    category: {
      tag: "ML specialization",
      color: "#6a5acd",
    },
  },
];

export default timelineData;
